// 올린 순서로 명단 학생을 채우는 계산. 스캔 PDF는 페이지 순서가 뒤섞인 경우가 많아서,
// 확정 연결 두 개가 같은 간격(올린 순서 차이 = 명단 번호 차이)으로 맞을 때 그 사이만 '확인됨'으로 본다.
// 그 밖(첫 연결 앞, 마지막 연결 뒤, 연결이 하나도 없을 때)은 '추정'이라 경고와 미리보기를 거쳐야 한다.

const toAnchors = (links, numberBySid) => Object.entries(links || {})
  .filter(([, sid]) => sid && numberBySid.has(sid))
  .map(([index, sid]) => ({ index: Number(index), number: numberBySid.get(sid) }))
  .sort((a, b) => a.index - b.index);

export const planOrderFill = ({ openIndexes, links, rosterStudents }) => {
  const open = new Set(openIndexes || []);
  const numberBySid = new Map((rosterStudents || []).map(student => [student.sid, Number(student.number)]));
  const sidByNumber = new Map((rosterStudents || []).map(student => [Number(student.number), student.sid]));
  const usedSids = new Set(Object.values(links || {}).filter(Boolean));
  const anchors = toAnchors(links, numberBySid);
  const verified = [];
  const guessed = [];
  const planned = new Set();

  const take = (index, number, bucket) => {
    const sid = sidByNumber.get(number);
    if (!open.has(index) || planned.has(index) || !sid || usedSids.has(sid)) return;
    usedSids.add(sid);
    planned.add(index);
    bucket.push({ index, sid, number });
  };

  for (let k = 0; k + 1 < anchors.length; k += 1) {
    const from = anchors[k];
    const to = anchors[k + 1];
    if (to.index - from.index !== to.number - from.number) continue;
    for (let index = from.index + 1; index < to.index; index += 1) {
      take(index, from.number + (index - from.index), verified);
    }
  }

  const sortedOpen = [...open].sort((a, b) => a - b);
  if (anchors.length === 0) {
    sortedOpen.forEach(index => take(index, index + 1, guessed));
  } else {
    const first = anchors[0];
    const last = anchors[anchors.length - 1];
    sortedOpen
      .filter(index => index < first.index)
      .forEach(index => take(index, first.number - (first.index - index), guessed));
    sortedOpen
      .filter(index => index > last.index)
      .forEach(index => take(index, last.number + (index - last.index), guessed));
  }

  return { verified, guessed, anchorCount: anchors.length };
};

// 바로 앞 카드에 연결한 학생의 다음 번호(없으면 서버가 떼어 낸 번호)를 추천한다.
export const suggestNextSid = ({ index, links, rosterStudents, numberHint, usedSids }) => {
  const byNumber = new Map((rosterStudents || []).map(student => [Number(student.number), student.sid]));
  const numberBySid = new Map((rosterStudents || []).map(student => [student.sid, Number(student.number)]));
  const free = (sid) => sid && !(usedSids || new Set()).has(sid);
  const hinted = byNumber.get(Number(numberHint));
  if (free(hinted)) return hinted;
  const previous = Object.entries(links || {})
    .map(([key, sid]) => ({ index: Number(key), sid }))
    .filter(item => item.index < index && numberBySid.has(item.sid))
    .sort((a, b) => b.index - a.index)[0];
  if (!previous) return null;
  const next = byNumber.get(numberBySid.get(previous.sid) + (index - previous.index));
  return free(next) ? next : null;
};
